const coll = document.getElementsByClassName("collapsible-header");

for (let i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        // Cierra todos los demás
        for (let j = 0; j < coll.length; j++) {
            if (coll[j] !== this) {
                coll[j].classList.remove("collapsible-active");
                const otherContent = coll[j].nextElementSibling;
                if (
                    otherContent &&
                    otherContent.classList.contains("collapsible-content")
                ) {
                    otherContent.style.maxHeight = null;
                }
            }
        }

        // Toggle actual
        this.classList.toggle("collapsible-active");
        const content = this.nextElementSibling;

        if (content && content.classList.contains("collapsible-content")) {
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }
    });
}

// 👉 Abrir el primero al cargar
// if (coll.length > 0) {
//   coll[0].classList.add('collapsible-active');
//   const firstContent = coll[0].nextElementSibling;
//   if (firstContent && firstContent.classList.contains('collapsible-content')) {
//     firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
//   }
// }
